import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { isBrowser } from '../utils'
import { publicRequest } from './publicRequest'

export const addToCart = async (
  id: string | number,
  data: ICartRequestData
): Promise<ICartResponse> => {
  const response: AxiosResponse<ICartResponse, AxiosRequestConfig> =
    await publicRequest.post(
      `v1/event/${id}/add-to-cart/`,
      { data },
      {
        headers: {
          ...publicRequest.defaults.headers.common,
          'Referer-Url': isBrowser ? document.referrer : '',
        },
      }
    )
  return response.data
}

export const getCart = async (): Promise<IGetCartResponse> => {
  const response: AxiosResponse<IGetCartResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/cart`)
  return response.data
}
